// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowListModal-cls1_46O","cls2":"BulkFollowListModal-cls2_nbh BulkFollowListModal-cls1_46O"};